import { Injectable } from '@angular/core';
import { SetIsAuthenticated } from '@app/auth/store/auth.actions';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export interface AuthStateModel {
  isAuthenticated: boolean;
  roles: string[];
}

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    isAuthenticated: false,
    roles: [],
  },
})
@Injectable()
export class AuthState {
  @Selector()
  static isAuthenticated(state: AuthStateModel): boolean {
    return state.isAuthenticated;
  }

  @Selector()
  static getRoles(state: AuthStateModel): string[] {
    return state.roles;
  }

  @Action(SetIsAuthenticated)
  setAuthenticated(ctx: StateContext<AuthStateModel>, action: SetIsAuthenticated): AuthStateModel {
    return ctx.patchState({
      isAuthenticated: action.isAuthenticated,
      roles: action.roles,
    });
  }
}
